import React from 'react';

const CalendarIcon = ({ extraClasses, size = "small", ...otherProps }) => {
  return (
    <span
      role="img"
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}
      {...otherProps}
    >
      <span className={`oc-o-icon--calendar icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg viewBox="0 0 30 30">
          <path
            fill="#383632"
            d="M19.93 8.66V4.35h-1v5.22l1-.91zm-9.06.05V4.35h-1v5.27l1-.91z"
          />
          <circle fill="#383632" cx={10.36} cy={12.25} r={0.96} />
          <circle fill="#383632" cx={14.97} cy={12.25} r={0.96} />
          <circle fill="#383632" cx={19.48} cy={12.25} r={0.96} />
          <circle fill="#383632" cx={10.36} cy={15.62} r={0.96} />
          <circle fill="#383632" cx={14.97} cy={15.62} r={0.96} />
          <circle fill="#383632" cx={19.48} cy={15.62} r={0.96} />
          <circle fill="#383632" cx={10.36} cy={18.99} r={0.96} />
          <circle fill="#383632" cx={14.97} cy={18.99} r={0.96} />
          <circle fill="#383632" cx={19.48} cy={18.99} r={0.96} />
          <path
            fill="#383632"
            d="M25.1 22.22V6.61h-19L4.84 7.86v15.73H24zM5.84 7.61H24.1v15H5.84z"
          />
        </svg>
      </span>
    </span>
  );
};

export default CalendarIcon;
